import { Box } from "@mui/material";

const Badge = ({ children, size = 36 }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: "8px",
      backgroundColor: "#EAE7E6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      fontSize: "0.75rem",
      color: "#483C3B",
    }}
  >
    {children}
  </Box>
);

export default Badge;